import { DependencyList, useState, useEffect } from 'react';

export function usePromise<T>(promise: Promise<T> | (() => Promise<T>), deps?: DependencyList) {
    const [resolving, setResolving] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [result, setResult] = useState<T | null>(null);

    useEffect(
        () => {
            let disposed = false;
            const setState = (result: T | null, error: string | null, resolving: boolean) => {
                if (!disposed) {
                    setResult(result);
                    setError(error);
                    setResolving(resolving);
                }
            };
            setState(null, null, true);
            (async () => {
                try {
                    const result = await (typeof promise === 'function' ? promise() : promise);
                    setState(result, null, false);
                } catch (err) {
                    setState(null, err instanceof Error ? err.message : 'An error occurred', false);
                }
            })();
            return () => {
                disposed = true;
            };
        },
        deps ?? [promise],
    );

    return { resolving, error, result };
}
